var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.typed.data-view.js
// module id = 814
// module chunks = 0